/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

interface Props {
  fill?: string;
  colorClassName?: string;
}

const IconLockSmall = (props: Props) => (
  <svg height="16px" width="16px" viewBox="0 0 16 16">
    <path fill={props.fill} className={props.colorClassName} d="M10,5.8V4.52a1.9,1.9,0,0,0-.59-1.39,2,2,0,0,0-2.82,0A1.9,1.9,0,0,0,6,4.52V5.8ZM8,11.51a1.29,1.29,0,0,0,.91-.38,1.24,1.24,0,0,0,.39-.9,1.21,1.21,0,0,0-.39-.89,1.26,1.26,0,0,0-1.82,0,1.21,1.21,0,0,0-.39.89,1.24,1.24,0,0,0,.39.9A1.29,1.29,0,0,0,8,11.51ZM11.88,5.8a1.28,1.28,0,0,1,.91.37,1.19,1.19,0,0,1,.4.88v6.37a1.17,1.17,0,0,1-.4.87,1.29,1.29,0,0,1-.91.38H4.12a1.29,1.29,0,0,1-.91-.38,1.17,1.17,0,0,1-.4-.87V7.05a1.19,1.19,0,0,1,.4-.88,1.28,1.28,0,0,1,.91-.37h.64V4.52a3,3,0,0,1,1-2.25,3.26,3.26,0,0,1,4.58,0,3,3,0,0,1,1,2.25V5.8Z" />
  </svg>
);

const IconLockMedium = (props: Props) => (
  <svg height="24px" width="24px" viewBox="0 0 24 24">
    <path fill={props.fill} className={props.colorClassName} d="M15,8.7V6.78a2.8,2.8,0,0,0-.88-2.08,3,3,0,0,0-4.24,0A2.8,2.8,0,0,0,9,6.78V8.7Zm-3,8.57a1.89,1.89,0,0,0,1.36-.58,1.8,1.8,0,0,0,0-2.68,1.88,1.88,0,0,0-2.72,0,1.8,1.8,0,0,0,0,2.68A1.89,1.89,0,0,0,12,17.27ZM17.82,8.7a1.94,1.94,0,0,1,1.37.55,1.8,1.8,0,0,1,.59,1.32v9.55a1.76,1.76,0,0,1-.59,1.32,2,2,0,0,1-1.37.56H6.18a2,2,0,0,1-1.37-.56,1.76,1.76,0,0,1-.59-1.32V10.57a1.8,1.8,0,0,1,.59-1.32A1.94,1.94,0,0,1,6.18,8.7h1V6.78A4.53,4.53,0,0,1,8.57,3.41,4.71,4.71,0,0,1,12,2a4.71,4.71,0,0,1,3.43,1.41,4.53,4.53,0,0,1,1.44,3.37V8.7Z" />
  </svg>
);

const IconLockLarge = (props: Props) => (
  <svg height="36px" width="36px" viewBox="0 0 36 36">
    <path fill={props.fill} className={props.colorClassName} d="M22.5,13V10.17a4.21,4.21,0,0,0-1.33-3.12,4.51,4.51,0,0,0-6.34,0,4.21,4.21,0,0,0-1.33,3.12V13ZM18,25.9A2.85,2.85,0,0,0,20.05,25a2.74,2.74,0,0,0,0-4A2.85,2.85,0,0,0,16,21a2.74,2.74,0,0,0,0,4A2.85,2.85,0,0,0,18,25.9ZM26.73,13a2.88,2.88,0,0,1,2.05.84,2.65,2.65,0,0,1,.89,2V30.19a2.63,2.63,0,0,1-.89,2,2.88,2.88,0,0,1-2.05.84H9.27a2.88,2.88,0,0,1-2-.84,2.63,2.63,0,0,1-.89-2V15.86a2.65,2.65,0,0,1,.89-2A2.88,2.88,0,0,1,9.27,13H10.7V10.17a6.85,6.85,0,0,1,2.15-5.06A7.07,7.07,0,0,1,18,3a7.07,7.07,0,0,1,5.15,2.11,6.85,6.85,0,0,1,2.15,5.06V13Z" />
  </svg>
);

const IconLockXLarge = (props: Props) => (
  <svg height="56px" width="56px" viewBox="0 0 56 56">
    <path fill={props.fill} className={props.colorClassName} d="M35,20.29V15.81A6.57,6.57,0,0,0,32.94,11a7,7,0,0,0-9.88,0A6.57,6.57,0,0,0,21,15.81v4.48Zm-7,20a4.42,4.42,0,0,0,3.18-1.35,4.23,4.23,0,0,0,0-6.25,4.4,4.4,0,0,0-6.36,0,4.23,4.23,0,0,0,0,6.25A4.42,4.42,0,0,0,28,40.29Zm13.58-20a4.54,4.54,0,0,1,3.19,1.3,4.11,4.11,0,0,1,1.38,3.08V47A4.09,4.09,0,0,1,44.77,50a4.49,4.49,0,0,1-3.19,1.3H14.42A4.49,4.49,0,0,1,11.23,50,4.09,4.09,0,0,1,9.85,47V24.67a4.11,4.11,0,0,1,1.38-3.08,4.54,4.54,0,0,1,3.19-1.3h2.22V15.81A10.63,10.63,0,0,1,20,8a11,11,0,0,1,8-3.28A11,11,0,0,1,36,8a10.63,10.63,0,0,1,3.35,7.86v4.48Z" />
  </svg>
);

const IconLock = {
  Small: IconLockSmall,
  Medium: IconLockMedium,
  Large: IconLockLarge,
  Xlarge: IconLockXLarge,
};

export default IconLock;
